import { Box, Stack } from "@mui/material";
import {
  CategoryTitle,
  DiffRow,
} from "components/search/input/DifferencePanel/common";
import { MassDiff } from "components/search/input/DifferencePanel/MassDiff";
import { TFunction } from "i18next";
import { NameBasedMaterialLimit } from "store/api/generatedApi";

const collectCoefficientNames = (
  limits: (NameBasedMaterialLimit | null | undefined)[]
): string[] => {
  const names = new Set<string>();
  for (const limit of limits) {
    for (const coefficient of limit?.coefficients ?? []) {
      names.add(coefficient.material_constraint_class_name);
    }
  }
  return [...names].sort((a, b) => a.localeCompare(b));
};

const getCoefficient = (
  limit: NameBasedMaterialLimit | null | undefined,
  className: string
): number | undefined =>
  limit?.coefficients.find(
    (coefficient) => coefficient.material_constraint_class_name === className
  )?.coefficient;

interface CoefficientsSectionProps {
  previous: NameBasedMaterialLimit | null;
  updated: NameBasedMaterialLimit | null;
  t: TFunction;
  format: (value: number) => string;
}

export const CoefficientsSection = ({
  previous,
  updated,
  t,
  format,
}: CoefficientsSectionProps) => {
  const names = collectCoefficientNames([previous, updated]);
  if (names.length === 0) return null;
  return (
    <Box>
      <CategoryTitle>{t("coefficients")}</CategoryTitle>
      <Stack sx={{ mt: 0.5 }}>
        {names.map((className) => {
          const previousValue = getCoefficient(previous, className);
          const updatedValue = getCoefficient(updated, className);
          return (
            <DiffRow
              key={className}
              title={className}
              value={
                <MassDiff
                  previous={previousValue}
                  updated={updatedValue}
                  massUnit=""
                  format={format}
                />
              }
            />
          );
        })}
      </Stack>
    </Box>
  );
};
